import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorPage } from '@/components/errors';

const internalServerErrorSearchSchema = z.object({
  message: z.string().optional(),
  stack: z.string().optional(),
});

export const Route = createFileRoute('/error/500')({
  component: InternalServerErrorPage,
  validateSearch: internalServerErrorSearchSchema,
});

function InternalServerErrorPage() {
  const { message, stack } = Route.useSearch();

  return <ErrorPage status={500} message={message} stack={stack} />;
}
